import React from 'react'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import store from '../../../state/store'

class EnableAutomaticTrackButton extends React.Component {

  onClick = () => {
    store.emit('enquiry:automatic_track:enable', this.props.enquiry_id)
  }

  render() {
    const title = 'Click to enable automatic follow up & deactivation if no further communication is received'

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm" title={title}>
            Auto <ChevronDown className="size-3.5"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem onSelect={this.onClick}>Enable Autotrack</DropdownMenuItem>
          <DropdownMenuItem>Cancel</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default EnableAutomaticTrackButton
